'use strict';

const createComponentNamespace = ({ component, componentList, namespace, }) => {
    // adjusting the display name to make sure that the display name reflects the usage of the component
    for (const [componentName, component] of Object.entries({
        ...componentList,
    })) {
        component.displayName =
            `${namespace}.${componentName}`;
    }
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-894053907
    const ComponentNamespace = Object.assign(component, componentList);
    // Assigning the return value of this function will overwrite the display name of the main component so we cannot control that here
    // e.g const FormNamespace = createComponentNamespace({  component: Form,  componentList: {...}, namespace: 'Form' })
    // will implicitly set the display name of `<FormNamespace>` to "FormNamespace"
    return ComponentNamespace;
};

exports.createComponentNamespace = createComponentNamespace;
//# sourceMappingURL=createComponentNamespace.js.map
